import { Observable, of } from 'rxjs';

import { WorkPackageTypeDto } from '@api/backend-connector/models';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';
import { WorkPackageTypesService } from 'src/app/services/work-package-type.service';

type WorkPackageTypePickerContext = {
  projectOptions?: WorkPackageTypeDto[];
};

export class WorkPackageTypePickerHandler extends SmartPickerHandler<WorkPackageTypeDto> {
  constructor(
    private workPackageTypeService: WorkPackageTypesService,
    private context: WorkPackageTypePickerContext,
  ) {
    super({
      ...defaultSmartPickerOptions,
      virtualScroll: false,
      filter: {
        enabled: false,
      },
      initialFetchedItems: 20,
      preloadStrategy: { enabled: true, autoSelectSingleChoice: true },
    });
  }

  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<WorkPackageTypeDto>> {
    if (this.context.projectOptions) {
      return of({
        items: this.context.projectOptions,
        count: this.context.projectOptions.length,
        offset: 0,
        limit: this.context.projectOptions.length,
      });
    }

    return this.workPackageTypeService.listWorkPackageTypes({
      offset: params.offset,
      limit: params.limit,
      query: params.query,
      excludeIds: this.getExcludeIds(),
      sorting: ['-position'],
      // excludeIds: params.excludeIds,
    });
  }
}
